import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

interface AppRevealProps {
  children: ReactNode;
}

/**
 * Entrance wrapper for the main app content, played right after the
 * `SplashScreen` animates out (the parent `AnimatePresence` runs in
 * `mode="wait"`, so the splash fully exits before this enters).
 *
 * Intentionally animates ONLY `opacity` — not `transform`/`filter` — because
 * a lingering transform on this wrapper would establish a containing block and
 * break `position: fixed` descendants (e.g. the home barcode modal). The
 * dramatic motion lives on the splash exit (scale + fade); here we just
 * cross-fade the app in.
 */
export const AppReveal = ({ children }: AppRevealProps) => (
  <motion.div
    className="w-full"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5, ease: 'easeOut' }}
  >
    {children}
  </motion.div>
);
